import { render } from "./Pos.vue?vue&type=template&id=2280d65a&scoped=true"
import script from "./Pos.vue?vue&type=script&lang=js"
export * from "./Pos.vue?vue&type=script&lang=js"

import "./Pos.vue?vue&type=style&index=0&id=2280d65a&scoped=true&lang=css"
import "./Pos.vue?vue&type=style&index=1&id=2280d65a&lang=css"

import exportComponent from "/home/dyam/Documentos/ENSI/mi-stock-ensi-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2280d65a"]])

export default __exports__